var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6050",
    "data-name": "Group 6050",
    transform: "translate(0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2582",
    "data-name": "Rectangle 2582",
    transform: "translate(-0.023 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Message",
    "data-name": "Iconly/Bold/Message",
    transform: "translate(7.882 8.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message-2",
    "data-name": "Message",
    d: "M10.6,12.77H3.59A3.59,3.59,0,0,1,0,9.187v-5.6A3.59,3.59,0,0,1,3.59,0H10.6a3.612,3.612,0,0,1,2.54,1.051,3.555,3.555,0,0,1,1.05,2.532v5.6A3.59,3.59,0,0,1,10.6,12.77ZM2.862,3.721a.52.52,0,0,0-.379.159.542.542,0,0,0-.05.709l.093.092L5.753,7.2a2.22,2.22,0,0,0,1.384.482A2.256,2.256,0,0,0,8.526,7.2l3.2-2.561.057-.057a.549.549,0,0,0-.008-.709.59.59,0,0,0-.375-.185h-.03A.539.539,0,0,0,11,3.831L7.8,6.385A1.11,1.11,0,0,1,7.1,6.64a1.13,1.13,0,0,1-.712-.256L3.192,3.831A.552.552,0,0,0,2.862,3.721Z",
    fill: "#4165f6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEmailIcon);
export default __webpack_public_path__ + "static/media/profile-emailIcon.620f40cb8ed7690b4efe951148c1e29f.svg";
export { ForwardRef as ReactComponent };